import { z } from "zod";
import { safeFetch } from "../http/http";
import { requestor } from "../requestor";

const baseUrl = "https://albelli.design.vpsvc.com/api/v1/documents";

const albelliDocumentSchema = z.object({
  documentId: z.string(),
  name: z.string(),
  previewImage: z.object({
    imageId: z.string(),
    height: z.number(),
    width: z.number(),
    imageUrl: z.string().url(),
  }),
  canonicalId: z.string().optional(),
  productKey: z.string().optional(),
  mpv: z.string().optional(),
});

export type AlbelliDocument = z.infer<typeof albelliDocumentSchema>;

export async function fetchAlbelliDocument(
  documentId: string,
  authorizationHeader: string,
): Promise<AlbelliDocument> {
  return await safeFetch(
    albelliDocumentSchema,
    `${baseUrl}/${documentId}?includePreviewImageUrl=true&from=${requestor}`,
    {
      headers: { Authorization: authorizationHeader },
    },
  );
}
